exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".horizontal-scroll{width:calc(100vw - 16px)}.horizontal-scroll .btn-group{position:absolute;top:85px;right:0;left:0;z-index:10;display:flex;justify-content:space-between;align-items:center}.horizontal-scroll::-webkit-scrollbar{height:3px;display:none}.horizontal-scroll::-webkit-scrollbar-track{box-shadow:none;border-radius:7.5px;width:250px}.horizontal-scroll::-webkit-scrollbar-thumb{background:#001d38;height:5px;width:58px;border-radius:7.5px}.horizontal-scroll::-webkit-scrollbar-thumb:hover{background:#c2c2c2;width:250px}.horizontal-scroll .outer{display:inline-flex;flex:1;width:auto;height:100%;padding-left:4px;flex-flow:row nowrap;align-items:center}.horizontal-scroll .inner-content{flex-shrink:0;align-items:center;justify-content:center;width:281px;height:calc(100% - 40px);margin-right:20px}.horizontal-scroll .inner-content:last-of-type{margin-right:30px}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};